import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Creating the right environment for
                                                communicating your vision
                                            </div>
                                            <p>The two most important elements of the ‘environment’ you create
                                                are making sure you allocate
                                                enough time, and how you communicate. By ‘enough’ time, we mean
                                                more than you first think is
                                                necessary, because if you’re gabbling and checking your watch
                                                you’ll seem disengaged from your
                                                audience, which won’t win you any favours. Also, you need to
                                                give people time to assimilate what
                                                you’re saying as you say it. Besides, if you seem rushed you’ll
                                                be less engaging than you might
                                                otherwise be, or send an implicit message that ‘this is not a
                                                priority’.</p>
                                            <p>As to how you communicate, it’s important to seem confident both
                                                in what you’re saying and in
                                                your audience’s ability to enable your vision. There’s a
                                                psychological phenomenon known as the
                                                Pygmalion effect,<a className="superscripttext "
                                                                    href="further_info.php?course=300"><sup>5</sup></a> whereby
                                                high expectation elicits high performance – or, low expectation,
                                                low
                                                performance. There are plenty of examples where the expectations
                                                of influential people affect
                                                the performance of those around them.</p>
                                            <div className="border_subtitle">Explain the CAT (Context and
                                                Tasks)
                                            </div>
                                            <p>This is where your preparation will pay off. If you can clearly
                                                and confidently explain both the context
                                                and specific tasks required, you’re half-way to translating your
                                                vision effectively. Please remember
                                                that explaining one (context or tasks) without the other will
                                                greatly reduce your chance of success.</p>
                                            <div className="border_subtitle">Allow opportunities for questions
                                            </div>
                                            <div className="uiheading"><p>Try to anticipate potential questions
                                                and work out your responses or solutions. You might be
                                                asked:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>Who has responsibility for each part of the plan?</li>
                                                <li>What are the resources available for carrying out the
                                                    activities?
                                                </li>
                                                <li>What support is there to help ensure that the project
                                                    succeeds?
                                                </li>
                                            </ul>
                                            <p>The final stage, ‘Ask’, is described below.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>STEP 3 – ASK
                                            </div>
                                            <div className="uiheading"><p>The last stage is to ask your audience
                                                to generate actions based on the CAT (Context and Tasks)
                                                that you have described. Involving your audience has several
                                                important benefits:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>It helps to promote buy-in and ownership, as people are more
                                                    likely to feel responsible
                                                    for the outcomes
                                                </li>
                                                <li>It allows you to check people’s understanding of the CAT, as
                                                    well as the suitability
                                                    of their ideas
                                                </li>
                                                <li>It encourages them to generate their own mental models (i.e.
                                                    understanding of the
                                                    situation), which will be more elaborate and durable as a
                                                    result.
                                                </li>
                                            </ul>
                                            <p>More information about the importance of mental models and how
                                                effective models are generated
                                                is given below:</p>
                                            <div className="border_subtitle">Developing effective mental
                                                models
                                            </div>
                                            <div className="uiheading"><p>People learn by developing ‘mental
                                                models’ (an understanding of how something works). The more
                                                accurate the mental model, the more effective the person will be
                                                at executing a given task. For
                                                example, a car mechanic will have a mental model describing how
                                                an engine works. Mechanics with
                                                the most elaborate and accurate mental models will be better
                                                able to diagnose and repair problems.
                                                Psychological research on learning<a
                                                    className="superscripttext "
                                                    href="further_info.php?course=300"><sup>6</sup></a> shows
                                                that effective mental models are those which are:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>Detailed – all of the important issues are understood</li>
                                                <li>Robust – long lasting</li>
                                                <li>Flexible – able to develop new insights.</li>
                                            </ul>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}